import React from "react";
import { ModeRendererProps } from "./types";

export function AgamWeaveMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <g clipPath="url(#circleClip)">
        {Array.from({ length: 9 }).map((_, k) => (
          <g key={`h-${k}`} transform={`translate(0 ${-200 + k * 48}) rotate(15 397 540)`} opacity={0.9 - k * 0.06}>
            <rect x="0" y={520} width="794" height="36" fill="url(#spectrum)" />
          </g>
        ))}
        {Array.from({ length: 9 }).map((_, k) => (
          <g key={`v-${k}`} transform={`translate(0 ${-180 + k * 48}) rotate(-15 397 540)`} opacity={0.9 - k * 0.06}>
            <rect x="0" y={520} width="794" height="36" fill="url(#spectrumRadial)" />
          </g>
        ))}
      </g>
      <circle cx="397" cy="540" r="310" fill="none" stroke={brand.white} strokeWidth="2" />
    </g>
  );
}
